import { retryAsync } from './src-util-retry-async.js';

const pricePlatformBaseUrl = "https://api.price-platform-service-cdn.pai.vpsvc.com/v2/pricing";
const fetchProductPriceDetails = async (request) => {
  const url = `${pricePlatformBaseUrl}/tenant/${request.tenant}/locale/${request.locale}/lowest-price?requestor=${request.requestor}&pageId=${request.pageId}`;
  const retryCondition = (error) => {
    return typeof error === "object" && error !== null && "status" in error && error.status >= 500 && error.status < 600;
  };
  const response = await retryAsync(async () => {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(request)
    });
    if (!res.ok) {
      const error = new Error(res.statusText);
      error.status = res.status;
      throw error;
    }
    return res;
  }, { retryCondition });
  const responseData = await response.json();
  const priceDetails = {};
  responseData.forEach(
    (product) => {
      priceDetails[product.id] = {
        id: product.id,
        prices: product.prices ? updateProductPrices(product.prices) : product.prices,
        quantityMetaData: product.quantityMetaData,
        isError: !product.prices,
        /*
          This allows changing the requested strategy to configured strategy i.e. reconfigure
          requested strategy to something else [For future purposes only]
        */
        displayStrategy: product.displayStrategy
      };
    }
  );
  return priceDetails;
};
const updateProductPrices = (prices) => {
  const updatedEstimatedPrices = {};
  for (const [quantity, entry] of Object.entries(prices.estimatedPrices)) {
    const numericQuantity = Number(quantity);
    const setupFee = entry.subtotalAmounts?.setupFee;
    const includeSetupFee = setupFee && !setupFee.includedInTotals;
    const adjustedTotalListPrice = includeSetupFee ? {
      taxed: entry.totalListPrice.taxed + setupFee.discountedPrice.taxed,
      untaxed: entry.totalListPrice.untaxed + setupFee.discountedPrice.untaxed
    } : entry.totalListPrice;
    const adjustedTotalDiscountedPrice = includeSetupFee ? {
      taxed: entry.totalDiscountedPrice.taxed + setupFee.discountedPrice.taxed,
      untaxed: entry.totalDiscountedPrice.untaxed + setupFee.discountedPrice.untaxed
    } : entry.totalDiscountedPrice;
    updatedEstimatedPrices[numericQuantity] = {
      ...entry,
      totalListPrice: adjustedTotalListPrice,
      totalDiscountedPrice: adjustedTotalDiscountedPrice
    };
  }
  return {
    ...prices,
    estimatedPrices: updatedEstimatedPrices
  };
};

export { fetchProductPriceDetails };
//# sourceMappingURL=src-clients-pricePlatformServiceClient.js.map
